module.exports = __webpack_public_path__ + "img/step_award.cb62519e.png";